// İSG Portal — Global Uygulama Bağlantı Ayarları (app-store linkleri) API çağrısı.
// KAYNAK: api-contract.md §26 (App Settings). Global singleton (firma-bazlı DEĞİL) — iOS/Android
// mobil uygulama mağaza indirme linkleri platform-geneli tek satırlık ayardır.
//
// Bu istemci iki ucu taşır:
//   - Okuma (§26.1 `GET /app-settings`): herhangi bir kimlik-doğrulanmış principal
//     (user/supplier) okur (grant GEREKMEZ; kimlik yoksa `401`). İndirme ekranı/menüsü okur.
//   - Yazma (§26.2 `PUT /admin/app-settings`, IsSystemAdmin): global linkleri upsert eder;
//     yalnız web-expert admin alanı (sistem-admin) çağırır (brief 083). Grant'sız → `403`.
//
// Alanlar **boş olabilir** (`null`) — ayar henüz kaydedilmemişse (uygulama mağazada değil);
// istemci boşsa "yakında" gösterir. Envelope Result<T> → `value` (client.ts unwrap eder).

import { api } from './client';

/**
 * Global app-store linkleri — api-contract §26.1 (`AppLinkSettingsDto`). İkisi de **boş
 * olabilir** (`null`): ayar henüz kaydedilmemiş (uygulama mağazada değil) → istemci "yakında"
 * gösterir. Dolu değer `http`/`https` mutlak adrestir (backend doğrular).
 */
export interface AppLinkSettings {
  iosAppUrl: string | null;
  androidAppUrl: string | null;
}

/**
 * `GET /app-settings` (`get`, AllAuthorized) — global iOS/Android mağaza linklerini getirir.
 * Herhangi bir kimlik-doğrulanmış principal okur (grant gerekmez); kimlik yoksa `401`. Ayar
 * boşsa alanlar `null` döner.
 */
export function getAppSettings() {
  return api.get<AppLinkSettings>('app-settings');
}

/**
 * `PUT /admin/app-settings` girdisi (§26.2). Her iki alan da **opsiyonel**; verilen alan
 * yazılır, verilmeyen alan dokunulmaz. **Boş/whitespace** verilen alan **temizlenir**
 * (`null`'a set edilir — link kaldırma). Dolu değer `http`/`https` mutlak adres olmalıdır
 * (backend doğrular; değilse `400 VALIDATION_FAILED`/`INVALID_URL`).
 */
export interface AppLinkSettingsUpdate {
  iosAppUrl?: string | null;
  androidAppUrl?: string | null;
}

/**
 * `PUT /admin/app-settings` (`admin-app-settings/update`, **IsSystemAdmin**) — global
 * iOS/Android mağaza linklerini upsert eder (tek singleton satır). Grant'sız principal →
 * `403` (fail-closed); anonim → `401`. Başarıda güncel ayar (`AppLinkSettings`) döner.
 * `UpdatedBy` token principal'dan alınır (istemciden GÖNDERİLMEZ).
 */
export function updateAppSettings(input: AppLinkSettingsUpdate) {
  return api.put<AppLinkSettings>('admin/app-settings', { json: input });
}
